import React, { useEffect, useRef } from 'react';
import { ProductSellingGroups } from '@project-stories/ecommerce/Product/ProductSellingGroups/ProductSellingGroups';
import { AcceleratedCheckoutButtons } from "@shopify/checkout-sheet-kit";
import '../../sections/Popup/Popup.scss';

interface PopupProps {
  isOpen: boolean;
  setIsOpen: any;
  product: any;
  settings: any;
  translations: any;    
}

export function SubscribePopup({ 
  product,
  settings,
  isOpen,
  setIsOpen,
  translations
}: PopupProps) {

  const popupRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const closePopup = () => {
    setIsOpen(false);
    document.body.classList.remove('popup-active');
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
      closePopup();
    }
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  };

  // Add event listeners for click outside and escape key
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className={`popup-container subscribe-popup fixed inset-0 z-50 flex items-center justify-center ${isOpen ? 'block' : 'hidden'}`}
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div 
        className="popup-overlay fixed inset-0 bg-black transition-opacity"
        style={{ opacity: 0.5 }}
      ></div>
      
      {/* Popup Content */}
      <div 
        ref={popupRef} 
        className={`popup-content relative bg-white border-rhv-orange rounded-[32px] z-50 shadow-lg overflow-hidden max-w-4xl max-h-[90dvh] mx-4 sm:mx-auto animate-fade-in w-[80vw]`}

      >
        {/* Close Button */}
        <button
          onClick={closePopup}
          className={`popup-close-btn absolute top-4 left-4 bg-black text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-800 focus:outline-none z-10`}
          aria-label="Close popup"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>


        <div className="md:flex ">
          {/* Content wrapper */}
          <div className="popup-content-wrapper py-[32px] px-4 md:flex-1 ">
            <div className={`popup-header text-center max-w-[325px] lg:max-w-[400px] flex flex-col items-center mx-auto`}>
                <div className={`h5`}>{translations?.subscribe || 'Subscribe & Save'}</div>
            </div>
            <div> 
                <ProductSellingGroups         
                    product={product}
                    bundle={product?.bundle || null}
                    settings={settings?.section}
                    isInTile={true}
                    translations={translations} 
                />
            </div>
            <div className="add-to-cart-block"> 
                <ajax-cart-product-form className='w-full'>
                    <form
                    action='/cart/add'
                    id='product_form_id'
                    className={`product-form px-2 lg:px-7`}
                    noValidate
                    data-prodify-product-form
                    ref={formRef}
                    onSubmit={() => closePopup()}
                    >
                    <input type="hidden" name="id" value={`${product?.id}`} />
                    <input
                    type="hidden"
                    name="id"
                    value={product?.selected_or_first_available_variant?.id}
                    className="form-variant-id"
                    />

                    <input
                    type="hidden"
                    name="selling_plan"
                    value=""
                    className="form-selling-plan-id"
                    />

                    <input
                    type="hidden"
                    name="quantity"
                    value="1"
                    />

                    {  product?.variants[0]?.available
                        ? <button
                            className={`button button-primary w-full !mt-0`}
                            type="submit"
                          >{translations?.add_to_cart || 'Add to Cart'}</button>
                        : <button className={`button button-tertiary w-full !mt-0`} disabled>{translations?.out_of_stock || 'Out of stock'}</button>
                    }

                    <div
                        data-ajax-cart-errors='form'
                        className='text-xs text-error-1 mt-2'
                    ></div>
                    </form>
                </ajax-cart-product-form>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SubscribePopup;